

import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";


let UserCartRestServiceConfig: IRestfulConfigMap = {
    "userCartRestService": {
        // TODO base对应接口地址
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取购物车数据
            get: {
                method: "get",
                path: "api/user/shoppingCart",
                testPath: "api/user/shoppingCart",
                needCurrency: true
            },
            // 批量删除
            multiDelete: {
                method: "delete",
                path: "api/user/shoppingCart/items",
                testPath: "api/user/shoppingCart/items"
            },
            // 获取购物车项列表
            getItemList: {
                method: "get",
                path: "api/user/shoppingCart/items",
                testPath: "api/user/shoppingCart/items",
            },
            // 添加购物车项
            addToCart: {
                method: "post",
                path: "api/user/shoppingCart/items",
                testPath: "api/user/shoppingCart/items",

            },
            // 计算勾选项的结算价格
            totalPrice: {
                method: "get",
                path: "api/user/shoppingCart/items/totalPrice",
                testPath: "api/user/shoppingCart/items/totalPrice",
                paramDefaults: { itemIds: "@itemIds" }
            },
            // 获取购物车项数量
            totalQty: {
                method: "get",
                path: "api/user/shoppingCart/items/totalQty",
                testPath: "api/user/shoppingCart/items/totalQty"
            },
            // 移除购物车项
            deleteCartItem: {
                method: "delete",
                path: "api/user/shoppingCart/items/:shoppingCartItemId",
                testPath: "api/user/shoppingCart/items/:shoppingCartItemId",
                paramDefaults: { shoppingCartItemId: "@shoppingCartItemId" }
            },
            // 根据id获取指定购物车项
            getItem: {
                method: "get",
                path: "api/user/shoppingCart/items/:shoppingCartItemId",
                testPath: "api/user/shoppingCart/items/:shoppingCartItemId",
                paramDefaults: { shoppingCartItemId: "@shoppingCartItemId" }
            },
            // 更新购物车项
            // TODO 接口是否实现V2接口
            //  api/user/shoppingCart/items/:shoppingCartItemId
            updateItem: {
                method: "put",
                path: "api/user/shoppingCart/items/:shoppingCartItemId/v2",
                testPath: "api/user/shoppingCart/items/:shoppingCartItemId/v2",
                needCurrency: true,
                paramDefaults: {
                    shoppingCartItemId: "@shoppingCartItemId"
                }
            },

            // 批量获取购物车项
            getSpecificMultiItems: {
                method: "get",
                path: "api/user/shoppingCart/items",
                testPath: "api/user/shoppingCart/items",
                paramDefaults: { itemIds: "@itemIds" }
            },
            // 批量获取购物车项--优惠信息
            getDiscountsMultiItems: {
                method: "post",
                path: "api/user/shoppingCart/items/v2",
                needCurrency: true
            }
        }
    }
}

export { UserCartRestServiceConfig };